import React from "react";
import "./Yongjun_Geng.css";



const Yongjun_Geng = () => (

  <div id="yongjun" className='Yongjun_GengMain'>

  <a href={"https://www.linkedin.com/in/yongjun-geng-b934152/"} target={"_blank"}><h3 className="text-center" >Yongjun Geng</h3></a>
 
<p>Charles and I were co-workers in Motorola. I was always amazed at 
  Charles's deep knowlege and skills in C++ and Object Oriented Design. 
  He was the expert and the go-to person for me and other engineers 
  for questions in C++ and OO design.</p>

  </div>
);

export default Yongjun_Geng;


// WEBPACK FOOTER //
// ./src/components/AboutMe/Yongjun_Geng.js